import { Controller } from '@hotwired/stimulus';
import consumer from "../channels/consumer";

export default class extends Controller {
  connect() {
    this.channel = consumer.subscriptions.create(
      { channel: "RadarActivationChannel" },
      {
        received: this.handleReceived.bind(this),
        connected: () => {},
        disconnected: () => {}
      }
    );
  }

  handleReceived(data) {
    if (data.message === 'finished' || data.message === 'error') {
      this.fetchActivationStatus();
    }
  }

  fetchActivationStatus() {
    fetch('/hudu_radar_settings/activation_status', {
      credentials: 'same-origin',
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
      }
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`Activation status fetch failed: ${response.status}`);
      }
      return response.text();
    })
    .then(html => Turbo.renderStreamMessage(html))
    .catch(error => {
      console.error(error);
    });
  }

  disconnect() {
    if (this.channel) {
      this.channel.unsubscribe();
    }
  }
}
